<div mat-dialog-title>
  <h1>{{data.title}}</h1>
  <button mat-icon-button [mat-dialog-close]="false" class="close">
    <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>
    {{data.text}}
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" color="accent">OK</button>
</mat-dialog-actions>
